export const UPDATE_CEK_KARTU_STATE = "UPDATE_CEK_KARTU_STATE"
export const RESET_CEK_KARTU_STATE  = "RESET_CEK_KARTU_STATE"

export const updateCekKartuState = (payload) => ({
    type : UPDATE_CEK_KARTU_STATE,
    payload
})

export const resetCekKartuState = () => ({
    type : RESET_CEK_KARTU_STATE
})


// WEBPACK FOOTER //
// ./src/actions/formCekKartuAction.js